import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";
import { cn } from "@/lib/utils";

export default function ThemeToggle({ className, size = "md" }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  const dim = size === "sm" ? "h-8 w-8" : "h-9 w-9";
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      data-testid="theme-toggle"
      className={cn(
        "rounded-full border border-border bg-card text-foreground grid place-items-center transition",
        "hover:bg-[hsl(var(--accent))] active:scale-95",
        dim,
        className
      )}
    >
      {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
}
